var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-card',{staticClass:"mb-3",attrs:{"border-variant":"danger","header":_vm.title,"header-border-variant":"danger","header-text-variant":"white","header-bg-variant":"danger"}},[_c('b-card-text',[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }